import ReactDOM from 'react-dom';
import React from 'react';
import {App} from './App';
import './index.scss';

const root = document.getElementById('root');

ReactDOM.render(<App/>, root);


// WEBPACK FOOTER //
// ./src/index.js